"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
Some files get virus scanned. This enum represents their status.
*/
var VirusScanStatus;
(function (VirusScanStatus) {
    VirusScanStatus[VirusScanStatus["NOT_SCANNED"] = 0] = "NOT_SCANNED";
    VirusScanStatus[VirusScanStatus["PROCESSING"] = 1] = "PROCESSING";
    VirusScanStatus[VirusScanStatus["INFECTED"] = 2] = "INFECTED";
    VirusScanStatus[VirusScanStatus["FAILED"] = 3] = "FAILED";
    VirusScanStatus[VirusScanStatus["READY"] = 4] = "READY";
})(VirusScanStatus = exports.VirusScanStatus || (exports.VirusScanStatus = {}));
// VirusScanStatusIsSafe returns true if the status represents a confirmed virus free scan, or a file that is not intended to be scanned
exports.VirusScanStatusIsSafe = (s = VirusScanStatus.FAILED) => [VirusScanStatus.READY, VirusScanStatus.NOT_SCANNED].indexOf(s) !== -1;
//# sourceMappingURL=virusScanStatus.js.map